import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import history from '../../navigation/history';
import app from './app-reducer';
import auth from './auth-reducer';
import user from './user-reducer';
import dailyInspiration from './daily-inspiration-reducer';
import quiz from './quiz-reducer';
import article from './article-reducer';
import articleCategory from './article-category-reducer';
import bibleQuote from './bible-quote-reducer';
import userQuizResult from './user-quiz-result-reducer';
import userQuiz from './user-quiz-reducer';
import conversationStarter from './conversation-starter-reducer';
import conversationStarterCategory from './conversation-starter-category-reducer';
import dateNight from './date-night-reducer';
import assessmentQuestion from './assessment-question-reducer';
import reward from './reward-reducer';
import dashboard from './dashboard-reducer';

export default combineReducers({
    app,
    auth,
    user,
    dailyInspiration,
    quiz,
    article,
    articleCategory,
    bibleQuote,
    dateNight,
    userQuizResult,
    userQuiz,
    conversationStarter,
    conversationStarterCategory,
    assessmentQuestion,
    reward,
    dashboard,
    router: connectRouter(history),
});
